/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { PermissionDto } from '../models';
// @ts-ignore
import type { UpdateUserDetailsRequestDto } from '../models';
// @ts-ignore
import type { UserDetailsDto } from '../models';
// @ts-ignore
import type { UserDetailsWithPermissionDto } from '../models';
// @ts-ignore
import type { UserSearchResponseDto } from '../models';
// @ts-ignore
import type { UserShortDto } from '../models';
// @ts-ignore
import type { UsersSearchRequestDto } from '../models';
/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserDetails', 'userId', userId)
            const localVarPath = `/api/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get user short details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShort: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserShort', 'userId', userId)
            const localVarPath = `/api/users/{userId}/short`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get users short list
         * @param {PermissionDto} [permission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersShort: async (permission?: PermissionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/short`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (permission !== undefined) {
                localVarQueryParameter['permission'] = permission;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get my details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search users
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: async (page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchUsers', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchUsers', 'pageSize', pageSize)
            // verify required parameter 'usersSearchRequestDto' is not null or undefined
            assertParamExists('searchUsers', 'usersSearchRequestDto', usersSearchRequestDto)
            const localVarPath = `/api/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usersSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user details
         * @param {string} userId 
         * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails: async (userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserDetails', 'userId', userId)
            // verify required parameter 'updateUserDetailsRequestDto' is not null or undefined
            assertParamExists('updateUserDetails', 'updateUserDetailsRequestDto', updateUserDetailsRequestDto)
            const localVarPath = `/api/users/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDetailsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserDetails(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserDetails(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get user short details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserShort(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserShortDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserShort(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUserShort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get users short list
         * @param {PermissionDto} [permission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserShortDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersShort(permission, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getUsersShort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get my details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailsWithPermissionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.me']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search users
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSearchResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsers(page, pageSize, usersSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.searchUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user details
         * @param {string} userId 
         * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserDetails(userId, updateUserDetailsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsDto> {
            return localVarFp.getUserDetails(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get user short details
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserShort(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserShortDto> {
            return localVarFp.getUserShort(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get users short list
         * @param {PermissionDto} [permission] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserShortDto>> {
            return localVarFp.getUsersShort(permission, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get my details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsWithPermissionDto> {
            return localVarFp.me(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search users
         * @param {number} page 
         * @param {number} pageSize 
         * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponseDto> {
            return localVarFp.searchUsers(page, pageSize, usersSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user details
         * @param {string} userId 
         * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateUserDetails(userId, updateUserDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - interface
 */
export interface UsersApiInterface {
    /**
     * 
     * @summary Get user details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserDetails(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsDto>;

    /**
     * 
     * @summary Get user short details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserShort(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserShortDto>;

    /**
     * 
     * @summary Get users short list
     * @param {PermissionDto} [permission] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserShortDto>>;

    /**
     * 
     * @summary Get my details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    me(options?: RawAxiosRequestConfig): AxiosPromise<UserDetailsWithPermissionDto>;

    /**
     * 
     * @summary Search users
     * @param {number} page 
     * @param {number} pageSize 
     * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<UserSearchResponseDto>;

    /**
     * 
     * @summary Update user details
     * @param {string} userId 
     * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI implements UsersApiInterface {
    /**
     * 
     * @summary Get user details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserDetails(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserDetails(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get user short details
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUserShort(userId: string, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUserShort(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get users short list
     * @param {PermissionDto} [permission] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersShort(permission?: PermissionDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getUsersShort(permission, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get my details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public me(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).me(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search users
     * @param {number} page 
     * @param {number} pageSize 
     * @param {UsersSearchRequestDto} usersSearchRequestDto Customer contacts search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchUsers(page: number, pageSize: number, usersSearchRequestDto: UsersSearchRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).searchUsers(page, pageSize, usersSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user details
     * @param {string} userId 
     * @param {UpdateUserDetailsRequestDto} updateUserDetailsRequestDto User details update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserDetails(userId: string, updateUserDetailsRequestDto: UpdateUserDetailsRequestDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserDetails(userId, updateUserDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

